var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02051 38.4999C8.02051 24.133 8.02051 16.9463 12.4833 12.4835C16.9461 8.02075 24.1295 8.02075 38.4997 8.02075C52.8666 8.02075 60.0533 8.02075 64.516 12.4835C68.9788 16.9463 68.9788 24.1298 68.9788 38.4999C68.9788 52.8668 68.9788 60.0535 64.516 64.5163C60.0533 68.9791 52.8698 68.9791 38.4997 68.9791C24.1328 68.9791 16.9461 68.9791 12.4833 64.5163C8.02051 60.0535 8.02051 52.87 8.02051 38.4999Z",
    stroke: "#019371",
    strokeWidth: 4.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6455 40.1042L19.1695 39.0903C20.687 38.0765 21.4474 37.5696 22.1789 37.7942C22.9072 38.022 23.2473 38.869 23.9274 40.5662L28.8747 52.9375L35.5737 32.8373C36.9853 28.6023 37.6912 26.4848 39.3723 25.2752C41.0535 24.0657 43.2865 24.0625 47.7493 24.0625H59.3538M54.5413 38.5L49.7288 43.3125M49.7288 43.3125L44.9163 48.125M49.7288 43.3125L54.5413 48.125M49.7288 43.3125L44.9163 38.5",
    stroke: "#019371",
    strokeWidth: 4.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsMath);
export default __webpack_public_path__ + "static/media/hugeicons_math.20502044d619c134fa2aa53f3cc8f9d9.svg";
export { ForwardRef as ReactComponent };